import styled from 'styled-components'

export const BlogPostContainer = styled.div<{ isSecondaryBlogPost: boolean }>`
  width: 100%;
  background: ${p =>
    p.isSecondaryBlogPost
      ? p.theme.webMktPalette.background.gray
      : p.theme.webMktPalette.background.white};
  position: relative;

  .BlogPost-Bg-Container {
    position: absolute;
    top: 0;
    height: 280px;
    width: 100%;
    max-width: 100%;
    background-size: 100%;
    background-repeat: no-repeat;
    background-image: ${p =>
      p.isSecondaryBlogPost
        ? `url(
            'https://images.ctfassets.net/5965pury2lcm/6yN08XkwEtkRdnasdX2DFS/5fcadd6978e925f596677c1e672d1706/HERO_Background__1_.png'
          )`
        : `url(
            'https://images.ctfassets.net/5965pury2lcm/3OgxA3z3S6rIykQkMMHxRI/0824d70c485ac3771022745f69963aae/heist-v2-blog-header-decoration.svg'
          )`};
    ${p => p.theme.breakpoints.down('sm')} {
      background-image: url('/steam-img/Grid-Partners.svg');
      background-repeat: repeat;
      background-size: unset;
      height: 100px;
    }
  }

  h1 {
    position: relative;
    z-index: 1;
  }

  .BlogPost__Body a {
    color: #08c;
  }

  .BlogPost__Breadcrumbs {
    position: relative;
    z-index: 1;
    display: flex;
    padding-top: 30px;
    margin-bottom: 80px;
  }

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .BlogPost__Breadcrumbs li {
    position: relative;
    z-index: 1;
    color: #0067df;
    font-family: 'Inter', sans-serif;
    font-weight: 800;
    font-size: 16px;
    color: #0067df;
    line-height: 24px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .BlogPost__Byline {
    z-index: 1;
    position: relative;
    display: inline-flex;
    align-items: center;
    margin-bottom: 32px;
  }

  .BlogPost__Byline > * {
    margin-right: 8px;
  }

  .BlogPost__Byline-Date {
    font-weight: bold;
  }

  .BlogPost__Post-Container {
    display: flex;
    justify-content: center;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .BlogPost__Image-Container {
    height: 600px;
    margin-bottom: 48px;

    ${p => p.theme.breakpoints.down('xs')} {
      height: 100%;
    }
  }

  .BlogPost__Image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .BlogPost__SocialMedia-Container {
    height: 100%;
    display: flex;
    margin-bottom: 34px;
    flex-direction: column;
    position: sticky;
    top: 120px;
  }

  .BlogPost__SocialMedia-Item {
    display: flex;
    flex-direction: column;
    width: 24px;
    height: 24px;
    margin-left: -126px;
    margin-right: 0;
    margin-bottom: 32px;
    top: 120px;
  }

  .BlogPost__SocialMedia-Item svg:hover {
    fill: ${p => p.theme.webMktPalette.icon.blueLight};
  }

  .BlogPost__Body-Container {
    max-width: 588px;
    width: 100%;
  }

  .BlogPost__Body > img {
    margin: 32px 0;
  }

  .BlogPost__Body div > img {
    max-height: 632px;
  }

  .BlogPost__Body > p {
    word-wrap: break-word;
    color: rgb(39, 49, 57);
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }

  .BlogPost__Body div {
    margin-top: 16px;
    margin-bottom: 32px;
    padding: 0;
  }

  .BlogPost__Body blockquote {
    background-color: ${p => p.theme.webMktPalette.background.gray};
    position: relative;
    margin: 80px 0 60px 0;
    border-left: 0;
    padding: 48px;
    ${p => p.theme.breakpoints.down('md')} {
      width: 632px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      width: 534px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      padding: 48px 24px;
      width: 327px;
    }
  }

  .BlogPost__Body blockquote::before {
    content: '';
    position: absolute;
    top: -30px;
    left: 48px;
    width: 74px;
    height: 56px;
    background-image: url('https://images.ctfassets.net/5965pury2lcm/6D8NmS3Zf7JZLkVIzD0UjL/97aa5dce32ab883531b4697ff3cf531e/heist-blog-blockquote-quotes.svg');
  }

  .BlogPost__Body blockquote > p {
    color: #273139;
  }

  .BlogPost__Body blockquote p:last-child,
  .BlogPost__Body blockquote p:last-child span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-top: 32px;
  }

  .BlogPost__Body blockquote p:first-child {
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    letter-spacing: -0.5px;
    ${p => p.theme.breakpoints.down('md')} {
      font-size: 20px;
      line-height: 32px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0px;
    }
  }

  .BlogPost__Body ul {
    list-style: none;
    margin-left: 26px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .BlogPost__Body ul > li > p {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
  }

  .BlogPost__Body ul > li {
    position: relative;
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    margin-bottom: 32px;
  }

  .BlogPost__Body ul li:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fa4616;
    position: absolute;
    top: 7px;
    left: -26px;
  }

  .BlogPost__Body > ol {
    list-style: decimal;
    margin-left: 20px;
    margin-top: 16px;
    margin-bottom: 32px;
  }

  .BlogPost__Body > ol > li > * {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    margin-bottom: 16px;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 48px 0;
  }

  .BlogPost__Tags-Container {
    padding-top: 25px;
    padding-bottom: 25px;
    border-top: 1px solid #d3d4d6;
    border-bottom: 1px solid #d3d4d6;
    margin-top: 32px;
  }

  .BlogPost__Tags-Heading {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    font-weight: 600;
    display: inline-flex;
  }

  .BlogPost__Tags > * {
    margin-right: 9px;
  }

  .BlogPost__Tag {
    display: inline-flex;
    padding-left: 16px;
    padding-right: 16px;
    border: 1px solid #e3e3e3;
    border-radius: 50px;
    margin-top: 9px;
    color: #273139;
  }

  .BlogPost__Author {
    display: flex;
    padding-top: 48px;
    padding-bottom: 96px;
  }
`

export const TagsContainer = styled.div`
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid #d3d4d6;
  border-bottom: 1px solid #d3d4d6;
  margin-top: 32px;
  .Tags__Heading {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    font-weight: 600;
    display: inline-flex;
  }

  .Tags__Group > * {
    margin-right: 9px;
  }

  .Tag {
    margin-right: 9px;
    display: inline-flex;
    padding-left: 16px;
    padding-right: 16px;
    border: 1px solid #e3e3e3;
    border-radius: 50px;
    margin-top: 9px;
    color: #273139;
  }
`
